module.exports = __webpack_public_path__ + "img/calendar3-fill.d7b94b54.svg";